import { useTranslation } from "react-i18next";
import '../assets/scss/components/skip-activation.scss';

function SkipReplacementFee({ initialValue = false, onChange, disabled = false }) {
  const { t } = useTranslation();
  return (
    <div className="mb-3 skip-activation">
      <input
        type="checkbox"
        checked={initialValue}
        onChange={onChange}
        className="form-check-input"
        id="skip_replace_fee"
        disabled={disabled}
      />
      <label className="mb-0" htmlFor="skip_replace_fee">
        {t("Skip Replacement Fee")}
      </label>
    </div>
  );
}

export default SkipReplacementFee;
